export const model = {
    id: null,
    client_id: 1,
    user_id: 1,
    comment: '',
    created_at: '',
    updated_at: '',
};
